export const environment = {
    envName: 'prod',
    production: true,
    apiUrl: 'https://pushbaza.com/',
    tokenUrl: 'https://pushbaza.com/connect/token'

  };



// WEBPACK FOOTER //
// ./src/app/environments/environment.prod.ts